"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCase = exports.createCaseTransformer = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const cases_1 = __importDefault(require("./cases"));
/**
 * Creates a utility that can easily transform a word to different casings
 *
 * @param word - The word to transform
 * @returns The word in a variety of cases
 */
function createCaseTransformer(word) {
    return (0, type_utils_1.apply)(cases_1.default, (func) => func(word));
}
exports.createCaseTransformer = createCaseTransformer;
/**
 * If a case function is provided it will be applied.
 * If a string is provided, it will attempt to lookup the case function in `cases`.
 *
 * @throws {Error} If the case function does not exist
 * @param word - The word to set the case of
 * @param transform - The case transformation function to apply
 * @returns The word transformed to the proper case
 */
function transformCase(word, transform) {
    // If no transformation provided, simply return the word
    if (!transform) {
        return word;
    }
    // If a function was provided, apply it
    if (typeof transform === 'function') {
        return transform(word);
    }
    // Check if cases has the function
    const caseTransform = cases_1.default[transform];
    // Apply the case transformation
    return caseTransform(word);
}
exports.transformCase = transformCase;
//# sourceMappingURL=transformCase.js.map